//Components
import Header from '../../components/pageHeader.js'

//Styling
import './dateRanges.scss'
import '../../dashboard.scss'

//Functions and Data
import config from './config.js'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React, { useEffect, useState } from 'react'
import { fetchAll } from '../../../../modules/users.js'
import { sendRequest } from '../../../../modules/admin.js'
import { fetchClass } from '../../../../modules/bookings.js'

import baseconfig from '../../../../variables/config.js'
import axios from 'axios'
import {
  createDefaultObj,
  parseTime,
  toTimeString,
  nullCoalesce
} from './misc.js'

const isStaffUser = () => {
  try {
    const { role } = JSON.parse(window.localStorage.getItem('userData'))
    return role === 'staff'
  } catch {
    return false
  }
}

const DateUpdater = ({ isOpen, sendRequest, bookings, users }) => {
  const [tab, setTab] = useState(0)
  const [tabs] = useState([
    {
      name: 'Party Dates',
      cb: () => {
        setTab(0)
        resetSelected()
      }
    },
    {
      name: 'Play Only Dates',
      cb: () => {
        setTab(1)
        resetSelected()
      }
    }
  ])
  const [playOnlyDates, setPlayOnlyDates] = useState([])
  const [partyDates, setPartyDates] = useState([])
  const [timeSlotInputs, setTimeSlotInputs] = useState([[], []])
  const [selected, setSelected] = useState(-1) //selected index
  const [isEditing, setEditing] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isAdding, setAdding] = useState(false) //in the process of adding a new date obj
  const [defaultObj] = useState(createDefaultObj())
  const [unauthorised] = useState(isStaffUser)

  const [token] = useState(
    JSON.parse(window.localStorage.getItem('userData')).token
  )

  useEffect(() => {
    if (unauthorised) return
    sendRequest(fetchAll)
    fetchDates('BookingDates')
    fetchDates('PlayOnlyBookingDates')
    console.log({ defaultObj })
  }, [])

  useEffect(() => {
    if (users.length > 0) {
      sendRequest(fetchClass)
    }
  }, [users])

  const _url = (modelType, id = null) => {
    let model = modelType + baseconfig.endpoint //e.g. PlayOnlyBookingDates + Kingstons
    let str = baseconfig.serverURL + '/' + model
    if (id) str += '/' + id
    return str + '?access_token=' + token
  }

  const fetchDates = (type, cb) => {
    setLoading(true)
    axios
      .get(_url(type))
      .then(res => {
        console.log({ kirbyDates: res.data, type })
        const dates = res.data
        dates.sort((a, b) => {
          const dateA = new Date(a.startDate)
          const dateB = new Date(b.startDate)
          return dateA - dateB
        })
        switch (type) {
          case 'PlayOnlyBookingDates':
            setPlayOnlyDates([...dates])
            break
          case 'BookingDates':
            setPartyDates([...dates])
            break
        }
        prepInputs(type, dates.length)
      })
      .catch(err => console.log({ err }))
      .finally(() => {
        if (cb) cb()
        setLoading(false)
        if (isAdding) {
          setAdding(false)
          resetSelected()
        }
      })
  }

  const prepInputs = (which, length) => {
    const arr = Array.from({ length }, (v, i) =>
      Array.from({ length: 7 }, (v2, i2) => ({ from: '', to: '' }))
    )

    switch (which) {
      case 'PlayOnlyBookingDates':
        timeSlotInputs[1] = arr
        break
      case 'BookingDates':
        timeSlotInputs[0] = arr
        break
    }

    setTimeSlotInputs([...timeSlotInputs])
  }

  const updateDate = dateObj => {
    setLoading(true)

    const isValid = validateDate(dateObj.startDate, dateObj.endDate)
    if (!isValid) {
      setLoading(false)
      return
    }

    const { id } = dateObj

    delete dateObj.id

    const modelType = tab === 0 ? 'BookingDates' : 'PlayOnlyBookingDates'

    axios
      .patch(_url(modelType, id), dateObj)
      .then(res => {
        console.log({ kirbyPatch: res })
        fetchDates(modelType, () => resetSelected())
      })
      .catch(err => console.log({ err }))
      .finally(() => setLoading(false))
  }

  const insertDate = dateObj => {
    setLoading(true)

    const isValid = validateDate(dateObj.startDate, dateObj.endDate)
    if (!isValid) {
      setLoading(false)
      return
    }

    const modelType = tab === 0 ? 'BookingDates' : 'PlayOnlyBookingDates'

    axios
      .post(_url(modelType), dateObj)
      .then(res => {
        console.log({ kirbyPost: res })
        setEditing(false)
        fetchDates(modelType)
      })
      .catch(err => console.log({ err }))
      .finally(() => {
        setLoading(false)
      })
  }

  const resetSelected = () => {
    setSelected(-1)
    setEditing(false)
  }

  const updateSelected = index => {
    if (index === selected) {
      setSelected(-1)
    } else {
      setSelected(index)
    }
    if (index === 0 && isAdding) {
      setEditing(true)
      return
    }
    setEditing(false)
  }

  const addNewDateObj = () => {
    const arr = tab === 0 ? partyDates : playOnlyDates
    if (!arr[0].id) {
      alert('Please save the current new date range before adding another.')
      return
    }
    switch (tab) {
      case 0:
        setPartyDates([{ ...defaultObj }, ...arr])
        prepInputs('BookingDates', arr.length + 1)
        break
      case 1:
        setPlayOnlyDates([{ ...defaultObj }, ...arr])
        prepInputs('PlayOnlyBookingDates', arr.length + 1)
        break
    }
    setSelected(0)
    setEditing(true)
    setAdding(true)
  }

  const updateDateObj = (index, data) => {
    const arrToUpdate = tab === 0 ? partyDates : playOnlyDates
    const arr = [...arrToUpdate]

    arr[index] = { ...arrToUpdate[index], ...data }

    switch (tab) {
      case 0:
        setPartyDates(arr)
        break
      case 1:
        setPlayOnlyDates(arr)
        break
    }
  }

  const addTimeslot = (model, index, day) => {
    const { from, to } = timeSlotInputs[model][index][day]
    if (from === '' || to === '') {
      alert('Please select both times for the timeslot')
      return
    }

    //string format is always dd:dd

    const fromNums = [
      new Number(from[0] + from[1]),
      new Number(from[3] + from[4])
    ]
    const toNums = [new Number(to[0] + to[1]), new Number(to[3] + to[4])]

    const compareTimes = (startHr1, startMin1, startHr2, startMin2) => {
      if (
        startHr1 < startHr2 ||
        (startHr1 === startHr2 && startMin1 < startHr2)
      )
        return -1
      if (startHr1 === startHr2 && startMin1 === startMin2) return 0
      return 1
    }

    if (compareTimes(fromNums[0], fromNums[1], toNums[0], toNums[1]) === 1) {
      alert('From time selected must be befores selected To time')
      return
    }

    // timeslot format is hour:minute[am|pm] - hour:minute[am|pm]
    const str = toTimeString([fromNums[0], fromNums[1], toNums[0], toNums[1]])

    const comparator = (slot1, slot2) => {
      const [startHr1, startMin1] = parseTime(slot1)
      const [startHr2, startMin2] = parseTime(slot2)

      return compareTimes(startHr1, startMin1, startHr2, startMin2)
    }

    //console.log('addTimeslot: ', { str })

    switch (model) {
      case 0:
        partyDates[index][day].timeSlots.push(str)
        partyDates[index][day].timeSlots.sort(comparator)
        setPartyDates([...partyDates])
        break
      case 1:
        playOnlyDates[index][day].timeSlots.push(str)
        playOnlyDates[index][day].timeSlots.sort(comparator)
        setPlayOnlyDates([...playOnlyDates])
        break
    }
  }

  const removeTimeSlot = (model, index, day, slotIndex) => {
    switch (model) {
      case 0:
        partyDates[index][day].timeSlots.splice(slotIndex, 1)
        setPartyDates([...partyDates])
        break
      case 1:
        playOnlyDates[index][day].timeSlots.splice(slotIndex, 1)
        setPlayOnlyDates([...playOnlyDates])
        break
    }
  }

  const handleTimeslotInputChange = (e, model, index, day, which) => {
    console.log({ value: e.target.value })
    timeSlotInputs[model][index][day][which] = e.target.value
    setTimeSlotInputs([...timeSlotInputs])
  }

  const handleDayObjectChange = (e, index, day, which) => {
    const arr = tab === 0 ? partyDates : playOnlyDates
    const dayObj = { ...arr[index][day], ...{ [which]: e.target.value } }

    if (which === 'capacity') {
      const _capacity = parseInt(e.target.value)
      if ((!_capacity && _capacity !== 0) || _capacity < 0) {
        delete dayObj.capacity
      } else {
        dayObj.capacity = _capacity
      }
    }

    if (which === 'peak') {
      dayObj.peak = e.target.value === 'true' ? true : false
    }

    console.log({ dayObj })

    updateDateObj(index, { [day]: dayObj })
  }

  const validateDate = (startDate, endDate) => {
    //date checks. Make sure startDate is before endDate and endDate is after startDate
    const _startDate = new Date(startDate)
    const _endDate = new Date(endDate)

    if (!_startDate.getTime()) {
      alert('Please insert a Start Date')
      return false
    }
    if (!_endDate.getTime()) {
      alert('Please insert an End Date')
      return false
    }
    if (_endDate.getTime() <= _startDate.getTime()) {
      //i.e. endDate is valid
      alert('Please make sure Start Date is before End Date')
      return false
    }
    return true
  }

  const handleInputDateChange = (e, index, which) => {
    const _date = new Date(e.target.value).toISOString()
    updateDateObj(index, { [which]: _date })
  }

  const handleEditClick = () => {
    if (isEditing) {
      //Clicked Cancel Changes
      setEditing(false)
      const cb = () => {
        if (isAdding) resetSelected()
      }
      fetchDates(tab === 0 ? 'BookingDates' : 'PlayOnlyBookingDates', cb)
    } else {
      //Clicked Edit Changes
      setEditing(true)
    }
  }

  const createDateObjComp = (dateObj, key) => {
    const isSelected = selected === key

    const detailsClass = 'itemRow' + (isSelected ? '' : ' hidden')

    const isObjToBeAdded = !dateObj.id

    const createTableHeader = () => {
      const headers = [
        '',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ]
      return (
        <thead>
          <tr>
            {headers.map((day, i) => (
              <th key={i}>{day}</th>
            ))}
          </tr>
        </thead>
      )
    }

    const createPeakRow = () => {
      const arr = []

      ;[-1, ...Array(7).keys()].map(index => {
        index === -1 ? arr.push('Peak/Off-Peak') : arr.push(dateObj[index].peak)
      })

      //console.log(arr)

      if (!isEditing) {
        return (
          <tr>
            {arr.map((val, i) =>
              i === 0 ? (
                <td key={i}>{val}</td>
              ) : (
                <td key={i}>{val ? 'Peak' : 'Off-Peak'}</td>
              )
            )}
          </tr>
        )
      } else {
        return (
          <tr>
            {arr.map((val, i) => (
              <td key={i}>
                {i === 0 ? (
                  val
                ) : (
                  <select
                    className="inputDateObj"
                    value={val}
                    onChange={e =>
                      handleDayObjectChange(e, key, i - 1, 'peak')
                    }>
                    <option value={true}>Peak</option>
                    <option value={false}>Off-Peak</option>
                  </select>
                )}
              </td>
            ))}
          </tr>
        )
      }
    }

    const createCapacityRow = () => {
      const arr = []

      /* The details for each day are in objects named 0 - 6.
      The Array(7).keys() creates an array of [0-7].
      The -1 at the start is for the left most table column with labels.
      */

      ;[-1, ...Array(7).keys()].map(index => {
        index === -1
          ? arr.push('Capacity')
          : arr.push(nullCoalesce(dateObj[index].capacity))
      })

      //console.log(arr)

      if (!isEditing) {
        return (
          <tr>
            {arr.map((val, i) =>
              i === 0 ? (
                <td key={i}>{val}</td>
              ) : (
                <td key={i}>{val || 'Default'}</td>
              )
            )}
          </tr>
        )
      } else {
        return (
          <tr>
            {arr.map((val, i) => (
              <td key={i} className="noBreak">
                {i === 0 ? (
                  val
                ) : (
                  <input
                    className="inputDateObj"
                    type="number"
                    min="0"
                    placeholder="Default"
                    value={val}
                    onChange={e =>
                      handleDayObjectChange(e, key, i - 1, 'capacity')
                    }
                  />
                )}
              </td>
            ))}
          </tr>
        )
      }
    }

    const createTimeslotsRow = () => {
      const arr = []

      ;[-1, ...Array(7).keys()].map(index => {
        index === -1
          ? arr.push(['Timeslots'])
          : arr.push(dateObj[index].timeSlots)
      })

      //console.log('key: ' + key, { arr })

      if (!isEditing) {
        return (
          <tr>
            {arr.map((val, i) => (
              <td key={i}>
                {val.map((slot, j) => (
                  <div key={j}>{slot}</div>
                ))}
              </td>
            ))}
          </tr>
        )
      } else {
        return (
          <tr>
            {arr.map((val, i) => (
              <td key={i} className="noBreak">
                {i === 0 ? (
                  val.map((slot, j) => (
                    <div key={j} className="noBreak">
                      <span>{slot}</span>
                    </div>
                  ))
                ) : (
                  <>
                    {val.map((slot, j) => (
                      <div key={j} className="individualTimeSlot">
                        <span>{slot}</span>
                        <span
                          onClick={() => removeTimeSlot(tab, key, i - 1, j)}>
                          ❌
                        </span>
                      </div>
                    ))}
                    <div className="dateObjAddTimeSlot">
                      <div>New Timeslot</div>
                      <div>
                        From:{' '}
                        <input
                          type="time"
                          value={
                            timeSlotInputs[0] && timeSlotInputs[0].length > 0
                              ? timeSlotInputs[tab][key][i - 1].from
                              : ''
                          }
                          onChange={e =>
                            handleTimeslotInputChange(
                              e,
                              tab,
                              key,
                              i - 1,
                              'from'
                            )
                          }
                        />
                      </div>
                      <div>
                        To:{' '}
                        <input
                          type="time"
                          value={
                            timeSlotInputs[0] && timeSlotInputs[0].length > 0
                              ? timeSlotInputs[tab][key][i - 1].to
                              : ''
                          }
                          onChange={e =>
                            handleTimeslotInputChange(e, tab, key, i - 1, 'to')
                          }
                        />
                      </div>
                      <div
                        className="buttonWrapper"
                        onClick={() => addTimeslot(tab, key, i - 1)}
                        disabled={isLoading}>
                        Add Timeslot
                      </div>
                    </div>
                  </>
                )}
              </td>
            ))}
          </tr>
        )
      }
    }

    const getInputDate = date => {
      //takes only the first part of the ISOString e.g. 2020-01-01
      return new Date(date).toISOString().split('T')[0]
    }

    const getDateString = date => {
      return date === 'endless'
        ? 'Indefinite'
        : new Date(date).toLocaleDateString('en-GB')
    }

    return (
      <div className="listItem" key={'dateObject' + key}>
        <div className="itemRow dateObjHeader">
          {(!isSelected || !isEditing || dateObj.endDate === 'endless') && (
            <div>
              {'Date Range: Start Date: ' +
                getDateString(dateObj.startDate) +
                ' -- ' +
                'End Date: ' +
                getDateString(dateObj.endDate)}
            </div>
          )}
          {dateObj.endDate !== 'endless' && isEditing && isSelected && (
            <div className="dateObjEditDates">
              <div className="noBreak">{'Start Date: '}</div>
              <input
                name={'startDate:' + key}
                className="inputDateObj"
                type="date"
                value={getInputDate(dateObj.startDate)}
                onChange={e => handleInputDateChange(e, key, 'startDate')}
              />
              <div className="noBreak">{'End Date: '}</div>
              <input
                name={'endDate:' + key}
                className="inputDateObj"
                type="date"
                value={getInputDate(dateObj.endDate)}
                onChange={e => handleInputDateChange(e, key, 'endDate')}
              />
            </div>
          )}
          {isObjToBeAdded && (
            <div className="dateObjNew"> {'Unsaved New Date Range'} </div>
          )}
          <div
            className="buttonWrapper"
            onClick={() => updateSelected(key)}
            disabled={isLoading}>
            {isSelected ? 'Hide Details' : 'Show Details'}
          </div>
        </div>
        <div className={detailsClass}>
          <table className={'dateObjTable'}>
            {createTableHeader()}
            <tbody>
              {createPeakRow()}
              {createCapacityRow()}
              {createTimeslotsRow()}
            </tbody>
          </table>
        </div>
        <div className={detailsClass}>
          <div
            className="buttonWrapper"
            onClick={() => handleEditClick()}
            disabled={isLoading}>
            {isEditing ? 'Cancel Changes' : 'Edit Details'}
          </div>
          {isEditing && (
            <div
              className="buttonWrapper"
              onClick={() =>
                isObjToBeAdded ? insertDate(dateObj) : updateDate(dateObj)
              }
              disabled={isLoading}>
              {isObjToBeAdded ? 'Save New Date Range' : 'Save Changes'}
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={'component' + (isOpen ? '' : ' componentClosed')}>
      {unauthorised && (
        <div className="unauthorisedMessage">
          You are not authorised to view calendar date ranges. Only
          administrators can access this page.
        </div>
      )}
      {!unauthorised && (
        <>
      <Header
        title={config.mainTitle}
        tip={config.subHeading}
        icon={config.titleIcon}
        tabs={tabs}
        selected={tab}
      />
      <div className="scrollView">
        {!isAdding && !isLoading && (
          <div className="listItem" onClick={() => addNewDateObj()}>
            <div className="buttonWrapper">{'Add New Date Range'}</div>
          </div>
        )}
        {tab === 0 && (
          <>{partyDates.map((date, i) => createDateObjComp(date, i))}</>
        )}
        {tab === 1 && (
          <>{playOnlyDates.map((date, i) => createDateObjComp(date, i))}</>
        )}
        {isLoading && <div className="loadingText">Loading Date Ranges...</div>}
      </div>
        </>
      )}
    </div>
  )
}

const mapStateToProps = ({ bookings, users }) => ({
  users: users.users,
  bookings: bookings.classBookings
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateUpdater)
